module.exports = __webpack_public_path__ + "img/show-bg.5f4ea770.png";